import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceCardPriceMHComponent } from './price-card-price.component';
import { PriceFormatModule } from '../format/price-format.module';
import { LoadingIndicatorComponent } from 'projects/shared/lib/components/shared/base/loading-indicator/loading-indicator.component';
import { PriceMissingInfoIconMHComponent } from '../price-missing-info-icon/price-missing-info-icon.component';
import { NoValidPriceComponent } from 'shared/components/shared/price/no-valid-price/no-valid-price.component';

@NgModule({
  declarations: [
    PriceCardPriceMHComponent,
  ],
  imports: [
    CommonModule,

    LoadingIndicatorComponent,
    PriceMissingInfoIconMHComponent,
    PriceFormatModule,
    NoValidPriceComponent,
  ],
  exports: [
    PriceCardPriceMHComponent,
  ]
})
export class PriceCardPriceModule { }
